<ng-container *ngIf="!(isLoading$ | async); else isLoadingState">
    <patient-schema-table [paginatedSchemas$]="paginatedSchemas$" [schemas$]="schemas$" [currentPage]="currentPage"
        [lastPage]="lastPage" [perPage]="perPage" [pages]="pages" [visiblePaginationPages]="visiblePaginationPages"
        [pagesIntervalSize]="pagesIntervalSize" [currentTab]="SchemaTab" [tabKey]="tabKey">
    </patient-schema-table>
</ng-container>

<ng-template #isLoadingState>
    <div class="text-center">
        <loading-spinner-border></loading-spinner-border>
    </div>
</ng-template>